// extracted by mini-css-extract-plugin
export default {"p_content":"a5829d59fd"};